import DynamicTemplate from "./DynamicTemplate";
export default DynamicTemplate;
